import { ImgBanner } from "./banner";
import puma from '../img/2025/desconto2/puma.png';
import pumaMob from '../img/2025/desconto2/pumaMob.png';
import camisafut from '../img/2025/desconto2/camisafut.png';
import camisafutMob from '../img/2025/desconto2/camisafutMob.png';
import tenniscorre from '../img/2025/desconto2/teniscorre.png';
import tenniscorreMob from '../img/2025/desconto2/teniscorreMob.png';
import tudoesp from '../img/2025/desconto2/tudoesp.png';
import tudoespMob from '../img/2025/desconto2/tudoespMob.png';

function BannersBlack() {
  //const bannerInternacional = 'https://blackfriday.futfanatics.com.br/img/banner/bannersblack/internacional.png';
  //const bannerNacional = 'https://blackfriday.futfanatics.com.br/img/banner/bannersblack/nacional.png';
  //const bannerSelecao = 'https://blackfriday.futfanatics.com.br/img/banner/bannersblack/selecao.png';
  //const bannerlicenciados = 'https://blackfriday.futfanatics.com.br/img/banner/bannersblack/licenciados.png';
  return (
    <>
      <div className="box-banner col-md-3">
        <a href='https://www.futfanatics.com.br/loja/busca.php?loja=311840&marca=marca_puma&range=&order=0'>
          <ImgBanner src={window.innerWidth >= 768 ? puma : pumaMob}></ImgBanner>
        </a>
      </div>
      <div className="box-banner col-md-3">
        <a href='https://www.futfanatics.com.br/clubes-brasileiros?loja=311840&categoria=11&variacao=tipo-de-produto_camisa&range=&order=4'>
          <ImgBanner src={window.innerWidth >= 768 ? camisafut : camisafutMob}></ImgBanner>
        </a>
      </div>
      <div className="box-banner col-md-3">
        <a href='https://www.futfanatics.com.br/calcados/corrida/?&order=3'>
          <ImgBanner src={window.innerWidth >= 768 ? tenniscorre : tenniscorreMob}></ImgBanner>
        </a>
      </div>
      <div className="box-banner col-md-3">
        <a href='https://www.futfanatics.com.br/esportes'>
          <ImgBanner src={window.innerWidth >= 768 ? tudoesp : tudoespMob}></ImgBanner>
        </a>
      </div>
    </>
  );
}
export default BannersBlack;
